import React, { useContext, useState } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  Dropdown,
  InputGroup,
  Spinner,
} from "@themesberg/react-bootstrap";
import { useCookies } from "react-cookie";
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { Context } from "../TicketReturn";
import ExportProcessingPopup from "../sub-screen/ExportProcessingPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faFilter, faCalendarAlt, faFileExport } from "@fortawesome/free-solid-svg-icons";
import { getAllChannel } from "../../../../controller/api/__classic__/channel";
import { includesSearchText } from "../../../../helper/text";

const RETURN_REASONS = [
  { key: "", label: "Tất cả lý do" },
  { key: "BAN_E", label: "Bán ế" },
  { key: "HET_VE", label: "Hết vé" },
  { key: "VE_HU", label: "Vé hư" },
  { key: "LY_DO_KHAC", label: "Lý do khác" },
];

const REGIONS = [
  { key: "", label: "Tất cả vùng" },
  { key: "MN", label: "Miền Nam" },
  { key: "MT", label: "Miền Trung" },
  { key: "MB", label: "Miền Bắc" },
];

const FilterForm = () => {
  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(["lottmekong"]);

  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [region, setRegion] = useState("");
  const [reason, setReason] = useState("");
  const [channelId, setChannelId] = useState("");
  const [channels, setChannels] = useState([]);
  const [channelSearch, setChannelSearch] = useState("");
  const [showExport, setShowExport] = useState(false);

  React.useEffect(() => {
    const fetchChannels = async () => {
      setChannelId("");
      const response = await getAllChannel(cookies.lottmekong, region || "MN");
      if (response && response.data) {
        setChannels(response.data);
      } else {
        setChannels([]);
      }
    };
    fetchChannels();
  }, [region, cookies.lottmekong]);

  const filteredChannels = channelSearch
    ? channels.filter((channel) =>
        includesSearchText(channel.name, channelSearch),
      )
    : channels;

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch({
      type: "SUBMIT_FILTER",
      payload: {
        from: from ? from.toDate() : null,
        to: to ? to.toDate() : null,
        region,
        reason,
        channelId,
      },
    });
  };

  const handleExport = () => {
    setShowExport(true);
  };

  return (
    <>
      <Card border="light" className="shadow-sm border-0 mb-3">
        <Card.Body className="p-3">
          <div className="d-flex align-items-center mb-3">
            <div className="icon icon-shape icon-sm shadow-sm border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
              <FontAwesomeIcon icon={faFilter} className="text-primary" />
            </div>
            <h6 className="mb-0">Hoàn vé</h6>
          </div>

          <Form onSubmit={handleSubmit}>
            <Row className="g-3 align-items-end">
              <Col xs={12} md={6} xl={2}>
                <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Từ ngày</Form.Label>
                <Datetime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  onChange={setFrom}
                  value={from}
                  renderInput={(props, openCalendar) => (
                    <InputGroup className="input-group-merge">
                      <InputGroup.Text className="bg-white border-end-0">
                        <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        className="border-start-0 ps-0"
                        value={from ? moment(from).format("DD/MM/YYYY") : ""}
                        placeholder="Chọn ngày"
                        onFocus={openCalendar}
                        onChange={() => {}}
                      />
                    </InputGroup>
                  )}
                />
              </Col>

              <Col xs={12} md={6} xl={2}>
                <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Đến ngày</Form.Label>
                <Datetime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  onChange={setTo}
                  value={to}
                  renderInput={(props, openCalendar) => (
                    <InputGroup className="input-group-merge">
                      <InputGroup.Text className="bg-white border-end-0">
                        <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        className="border-start-0 ps-0"
                        value={to ? moment(to).format("DD/MM/YYYY") : ""}
                        placeholder="Chọn ngày"
                        onFocus={openCalendar}
                        onChange={() => {}}
                      />
                    </InputGroup>
                  )}
                />
              </Col>

              <Col xs={12} md={6} xl={2}>
                <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Vùng</Form.Label>
                <Form.Select
                  value={region}
                  onChange={(e) => setRegion(e.target.value)}
                  className="bg-white"
                >
                  {REGIONS.map((r) => (
                    <option key={r.key} value={r.key}>
                      {r.label}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col xs={12} md={6} xl={2}>
                <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Đài (Tỉnh)</Form.Label>
                <Dropdown className="w-100">
                  <Dropdown.Toggle
                    variant="white"
                    className="w-100 text-start d-flex align-items-center justify-content-between form-control bg-white border"
                    id="dropdown-channel-select"
                  >
                    <span className="text-truncate">
                      {channelId
                        ? channels.find(
                            (ch) => String(ch.id) === String(channelId),
                          )?.name || "Tất cả đài"
                        : "Tất cả đài"}
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="w-100 p-2 shadow-sm"
                    style={{ maxHeight: "300px", overflowY: "auto" }}
                  >
                    <div className="px-1 mb-2 sticky-top bg-white">
                      <InputGroup>
                        <InputGroup.Text className="bg-white border-end-0">
                          <FontAwesomeIcon
                            icon={faSearch}
                            className="text-muted"
                          />
                        </InputGroup.Text>
                        <Form.Control
                          autoFocus
                          placeholder="Tìm đài..."
                          value={channelSearch}
                          onChange={(e) => setChannelSearch(e.target.value)}
                          className="bg-white border-start-0 ps-0"
                          onClick={(e) => e.stopPropagation()}
                        />
                      </InputGroup>
                    </div>

                    <Dropdown.Item
                      active={channelId === ""}
                      onClick={() => {
                        setChannelId("");
                        setChannelSearch("");
                      }}
                      className="rounded-2"
                    >
                      Tất cả đài
                    </Dropdown.Item>

                    {filteredChannels.length > 0 ? (
                      filteredChannels.map((channel) => (
                        <Dropdown.Item
                          key={channel.id}
                          active={String(channelId) === String(channel.id)}
                          onClick={() => {
                            setChannelId(channel.id);
                            setChannelSearch("");
                          }}
                          className="rounded-2"
                        >
                          {channel.name}
                        </Dropdown.Item>
                      ))
                    ) : (
                      <div className="text-center text-muted small py-2">
                        Không tìm thấy đài
                      </div>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>

              <Col xs={12} md={6} xl={2}>
                <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Lý do</Form.Label>
                <Form.Select
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  className="bg-white"
                >
                  {RETURN_REASONS.map((r) => (
                    <option key={r.key} value={r.key}>
                      {r.label}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col xs={12} className="mt-3 pt-3 border-top">
                <div className="d-flex justify-content-end gap-2">
                  <Button
                    variant="primary"
                    type="submit"
                    className="shadow-sm px-4"
                    disabled={state.isLoading}
                  >
                    {state.isLoading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Đang tải...
                      </>
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faSearch} className="me-2" />
                        Tìm kiếm
                      </>
                    )}
                  </Button>
                  <Button 
                    variant="success" 
                    onClick={handleExport}
                    className="shadow-sm px-4"
                    disabled={state.isLoading}
                  >
                    <FontAwesomeIcon icon={faFileExport} className="me-2" />
                    Xuất Excel
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <ExportProcessingPopup
        show={showExport}
        onHide={() => setShowExport(false)}
        filterData={{
          from: from ? from.toDate() : null,
          to: to ? to.toDate() : null,
          region,
          reason,
          channelId
        }}
      />
    </>
  );
};

export default React.memo(FilterForm);
